/**
 * Contact Team Utility
 * Handles email communication with the support team for various user requests
 */

/**
 * Email configuration for different types of support requests
 */
const EMAIL_CONFIG = {
  COLLATERAL_LIMIT_UPGRADE: {
    to: 'vcm@agentic.it',
    cc: 'anshul.sharma@agentic.it',
    subject: 'Collateral Creation',
//     body: `Hi Team,

// I've reached the current collateral creation limit on Heyparrot, and I'm unable to create any new collaterals at the moment.

// Could you please help revise or upgrade the collateral plan so I can continue creating new collaterals as needed?

// Thank you for your assistance.

// Best regards`
  },
  GENERAL_SUPPORT: {
    to: 'vcm@agentic.it',
    cc: 'anshul.sharma@agentic.it',
    subject: 'Support Request - Heyparrot',
    body: 'Hi Team,\n\nI need assistance with:\n\n[Please describe your issue]\n\nThank you.'
  }
};

/**
 * Constructs a mailto: URL with proper encoding
 * @param {Object} config - Email configuration object
 * @param {string} config.to - Primary recipient email
 * @param {string} config.cc - CC recipient email (optional)
 * @param {string} config.subject - Email subject
 * @param {string} config.body - Email body content
 * @returns {string} Properly encoded mailto URL
 */
const constructMailtoUrl = ({ to, cc, subject, body }) => {
  const params = new URLSearchParams();
  
  if (cc) {
    params.append('cc', cc);
  }
  
  if (subject) {
    params.append('subject', subject);
  }
  
  if (body) {
    params.append('body', body);
  }
  
  return `mailto:${to}?${params.toString()}`;
};

/**
 * Opens the user's default email client with pre-filled support email
 * @param {string} requestType - Type of support request (e.g., 'COLLATERAL_LIMIT_UPGRADE')
 * @param {Object} customConfig - Optional custom email configuration to override defaults
 */
export const contactSupportTeam = (requestType = 'COLLATERAL_LIMIT_UPGRADE', customConfig = null) => {
  const config = customConfig || EMAIL_CONFIG[requestType];
  
  if (!config) {
    console.error(`Unknown request type: ${requestType}`);
    return;
  }
  
  const mailtoUrl = constructMailtoUrl(config);
  
  // Open email client in new window/tab
  window.location.href = mailtoUrl;
};

/**
 * Request collateral limit upgrade
 * Opens email client with pre-filled upgrade request
 */
export const requestCollateralLimitUpgrade = () => {
  contactSupportTeam('COLLATERAL_LIMIT_UPGRADE');
};

/**
 * Request general support
 * Opens email client with basic support template
 */
export const requestGeneralSupport = () => {
  contactSupportTeam('GENERAL_SUPPORT');
};

/**
 * Get email configuration for a specific request type
 * Useful for displaying email details in UI without opening email client
 * @param {string} requestType - Type of support request
 * @returns {Object|null} Email configuration or null if not found
 */
export const getEmailConfig = (requestType) => {
  return EMAIL_CONFIG[requestType] || null;
};

export default {
  contactSupportTeam,
  requestCollateralLimitUpgrade,
  requestGeneralSupport,
  getEmailConfig
};

